<template lang="pug">
  section(id="platform")
    .goscontainer
      v-row.heading(no-gutters)
        v-col(cols=12 md=7)
          .path Наши программные решения > 
            span Платформа СУДЕБНЫЙ ПОРТАЛ
          .titl Платформа СУДЕБНЫЙ ПОРТАЛ
          .txt Модульная многопользовательская платформа для аппарата суда и участников судопроизводства
          .txt Создано с учетом потребностей профессионального сообщества
        v-col.align-content-end.justify-content-between(cols=12 md=5)
          v-img.ml-auto(:src="require('@/assets/img/page/box1.svg')" max-width="330")

      .panel 
        .desc
          .titl Состав продукта 

          div Функциональные программные модули:
          ul
            li Управление делами
            li Закрытое облачное хранилище
            li База знаний
            li Отправка заказных писем
            li Распределение дел

        .feature( v-for="(feature, i) in features" :key="i")
        
            div.d-flex
              div.ico.d-flex.align-content-center.flex-wrap
                img(:src="require(`@/assets/img/page/${feature.icon}.svg`)" width="96" height="96")
            
              div.ma-6
                div.titl(v-html="feature.title")
                div.text(v-html="feature.text")

            
</template>

<script>
  export default {
    name: 'Platform',
    data: () => ({
      features: [
        {

          title: 'Управление делами',
          text: '<div class="subtitle">Возможности МОДУЛЯ:</div>'+
              '<ul>'+
              '<li>  Автоматическая синхронизация с базой ГАС "Правосудие"'+
              '<li> Оповещения в органайзере, составление персонального расписания заседаний, встреч, дел'+
              '<li> Просмотр списка моих дел, поиск дел '+
              '<li> Работа с делом - создание повесток, запросов, других документов на основе шаблонов и автозаполнением полей из информации по делу'+
              '<li> Отправка созданных документов по электронной почте'+
              '<li> Гибкая настройка шаблонов запросов по способу доставки - по  электронной почте, шифрованной электронной почте, VIPNET'+
              '<li> Подписание ЭЦП группы документов'+
              '</ul>'+
              '<div class="subtitle">Эффекты от внедрения:</div>'+
              '<ul>'+
              '<li> Повышение эффективности и организации рабочего пространства аппарата суда'+
              '<li> Экономия на затратах по доставке корреспонденции'+
              '</ul>',
          icon: 'sp1',
        },
        {
          title: 'Закрытое облачное хранилище',
          text: '<div class="subtitle">Возможности МОДУЛЯ:</div>'+
              '<ul>'+
              '<li> Обеспечивает надежное хранение и доступ к документам судьи с любого компьютера суда     '+
              '<li> Удобный поиск по папкам, тегам документов                                               '+
              '<li> Удобное редактирование документов средствами MS Word без загрузки на локальный компьютер'+
              '<li> Возможность формирования библиотеки шаблонов для работы                                 '+
              '</ul>'+
              '<div class="subtitle">Эффекты от внедрения:</div>'+
              '<ul>'+
              '<li> Универсальный доступ к персональному файловому хранилищу с любого рабочего места     '+
              '<li> Защита сохранности информации                                                        '+
              '<li> Скорость работы судьи увеличивается за счет использования готовых технических решений'+
              '</ul>',
          icon: 'sp2',
        },
        {
          title: 'База знаний',
          text: '<div class="subtitle">Возможности МОДУЛЯ:</div>'+
              '<ul>'+
              '<li> Содержит в себе всю свежую необходимую нормативную документацию, используемую в ежедневной практике работы судейского аппарата.'+
              '<li> Обеспечивает мощные механизмы поиска, по типам документов, по метаописанию документов, по дате документа, по номеру документа  '+
              '<li> Дает возможность модератору базы знаний пополнять новые документы, работать с их метаописаниями                                '+
              '</ul>'+
              '<div class="subtitle">Эффекты от внедрения:</div>'+
              '<ul>'+
              '<li> Повышение информированности судей  и работников суда           '+
              '<li> Повышение общей культуры работы с полезной и ценной информацией'+
              '</ul>',
          icon: 'sp3',
        },
        {
          title: 'Отправка заказных писем',
          text: '<div class="subtitle">Возможности МОДУЛЯ:</div>'+
              '<ul>'+
              '<li> Взаимодействие с личным кабинетом почты РФ                                                                                                                                                                                                                                                       '+
              '<li> Полная автоматизация процесс формирование почтовых отправлений (электронных почтовых отправлений), присвоение штрих-почтовых идентификаторов юридически значимым сообщениям, а также передачи их во внешний контур доставки и вручения получателям (сторонам по делу, адвокатам, экспертам и др.)'+
              '<li> Автоматизация процесса формирования реестра                                                                                                                                                                                                                                                      '+
              '<li> Отслеживание статуса отправления с рабочего места судьи                                                                                                                                                                                                                                          '+
              '</ul>'+
              '<div class="subtitle">Эффекты от внедрения:</div>'+
              '<ul>'+
              '<li> Экономия бюджетов на почтовые расходы судов                    '+
              '<li> Оптимизация работы канцелярии                                  '+
              '<li> Оперативное информирование судей по статусу доставки документов'+
              '</ul>',
          icon: 'sp4',
        },
        {
          title: 'Распределение дел',
          text: '<div class="subtitle">Возможности МОДУЛЯ:</div>'+
              '<ul>'+
              '<li> Автоматическое и гибкое распределение дел по судьям в соответствии с заданными критериями (загрузка, тип дела, рейтинг судьи и др.), '+
              '<li> Учет отпусков, больничных, служебных командировок судей.                                                                             '+
              '<li> Возможность объединения категорий дел в составы                                                                                      '+
              '</ul>'+
              '<div class="subtitle">Эффекты от внедрения:</div>'+
              '<ul>'+
              '<li> Справедливое распределение нагрузки между судьями'+
              '<li> Уменьшение напряженности в коллективе            '+
              '</ul>',
          icon: 'sp5',
        },
      ],
    }),
  }
</script>

<style lang="sass" scoped>
  #platform
    padding: 16px 16px 0 16px 
    background-color: #FFFFFF
    color: #000000
    .heading 
      padding: 16px 96px
      margin-bottom:-200px
      .path 
        color: #505254
        font-size: 12px
        line-height: 32px
        span
          color: #959595
      .titl
        font-weight: bold
        font-size: 36px
        line-height: 48px
        text-transform: uppercase
        color: #0E9DBC
        margin-bottom: 24px
      .txt
        font-size: 18px
        line-height: 16px
        margin-bottom: 16px
    .panel
      background-color: #F3F3F3
      padding: 16px 96px
      .desc
        margin-bottom: 48px
        color: #0E9DBC
        font-size: 18px
        line-height: 24px
        ul
          list-style-type: square
        .titl
          font-weight: bold
          font-size: 24px
          line-height: 24px
          margin-bottom: 24px
      .feature
        margin-bottom: 24px
        background-color: #FFF
        box-shadow: 0 .2rem 1rem rgba(0, 0 , 0, .15)
        .ico
          padding: 16px
          background-color: #0E9DBC
        .titl
          font-weight: bold
          font-size: 24px
          line-height: 24px
          margin-bottom: 24px
        .text
          font-size: 14px
          line-height: 24px
          .subtitle
            margin-top: 24px
            color: #0E9DBC

  @media (max-width: 1180px) 
    #platform
      .heading 
        margin-bottom: -140px

  @media (max-width: 960px) 
    #platform
      .heading 
        padding: 16px 32px
        margin-bottom: 0
      .panel
        padding: 16px 32px
        .feature
          .ico
            padding: 8px
            img
              display: none
</style>

<style lang="sass">
  #platform
    .panel
      .feature
        .text
          .subtitle
            margin-top: 24px
            color: #0E9DBC
</style>
